/**
 * Created by Jerker Nord on 2020-01-31.
 */

export class MonkeysGoldParticleConfigs {

    public static allReelsFilledWin:any = {
        "alpha" : {
            "start" : 0,
            "end" : 1
        },
        "scale" : {
            "start" : 0.7,
            "end" : 0.1,
            "minimumScaleMultiplier" : 0.2
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#f29100"
        },
        "speed" : {
            "start" : 0,
            "end" : 20,
            "minimumSpeedMultiplier" : 10
        },
        "acceleration" : {
            "x" : 44,
            "y" : -78
        },
        "maxSpeed" : 62,
        "startRotation" : {
            "min" : 50,
            "max" : 70
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : -194,
            "max" : 192
        },
        "lifetime" : {
            "min" : 0.3,
            "max" : 1
        },
        "blendMode" : "add",
        "ease" : [
            {
                "s" : 0,
                "cp" : 0.379,
                "e" : 0.548
            },
            {
                "s" : 0.548,
                "cp" : 0.717,
                "e" : 0.676
            },
            {
                "s" : 0.676,
                "cp" : 0.635,
                "e" : 1
            }
        ],
        "frequency" : 0.009,
        "emitterLifetime" : -1,
        "maxParticles" : 70,
        "pos" : {
            "x" : 0,
            "y" : 0,
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : 1280,
            "h" : 720
        }
    };

    public static bigWinCoinRain:any = {
        "alpha" : {
            "start" : 1,
            "end" : 1
        },
        "scale" : {
            "start" : 0.7,
            "end" : 1,
            "minimumScaleMultiplier" : 0.8
        },
        "color" : {
            "start" : "#ffffff",
            "end" : "#ffffff"
        },
        "speed" : {
            "start" : 550,
            "end" : 600,
            "minimumSpeedMultiplier" : 0.6
        },
        "acceleration" : {
            "x" : 0,
            "y" : 100
        },
        "maxSpeed" : 0,
        "startRotation" : {
            "min" : 90,
            "max" : 90
        },
        "noRotation" : false,
        "rotationSpeed" : {
            "min" : 200,
            "max" : 400
        },
        "lifetime" : {
            "min" : 2,
            "max" : 2
        },
        "blendMode" : "add",
        "ease" : [
            {
                "s" : 0,
                "cp" : 0.379,
                "e" : 0.548
            },
            {
                "s" : 0.548,
                "cp" : 0.717,
                "e" : 0.676
            },
            {
                "s" : 0.676,
                "cp" : 0.635,
                "e" : 1
            }
        ],
        "frequency" : 0.04,
        "emitterLifetime" : -1,
        "maxParticles" : 250,
        "pos" : {
            "x" :  0,
            "y" : 0
        },
        "addAtBack" : false,
        "spawnType" : "rect",
        "spawnRect" : {
            "x" : 0,
            "y" : 0,
            "w" : 1,
            "h" : 1
        }
    };
}